import React, { useState } from "react";
import I18n from "i18n-js";


// Le frecce sono quelle esportate dal file Figma "Backoffice - Ordini di recesso"
const ICONS_PATH = '/images/icons/withdrawal_requests'

// Le date viaggiano come AAAA-MM-GG e si mostrano come GG/MM/AAAA. Sono costruite dai componenti
// locali della data, cosi' il fuso orario non le sposta di un giorno
const pad = (value) => String(value).padStart(2, '0')
export const dateKey = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
export const formatDateKey = (key) => key.split('-').reverse().join('/')

// Nomi di mesi e giorni nella lingua dell'interfaccia. I giorni partono dal lunedi': il 1 gennaio 2024
// lo era
const monthName = (month, format) => new Intl.DateTimeFormat(I18n.locale, { month: format }).format(new Date(2024, month, 1))
const WEEKDAYS = () => [...Array(7).keys()].map(day =>
  new Intl.DateTimeFormat(I18n.locale, { weekday: 'short' }).format(new Date(2024, 0, 1 + day)))


// Calendario per la scelta di una data singola, di un intervallo o di piu' date sparse: lo usano il filtro
// per data delle richieste di recesso nel backoffice e il popup di ricontatto del modulo di recesso. Il
// titolo passa dalla vista dei giorni a quella dei mesi e poi degli anni, per saltare velocemente lontano.
// isDayDisabled (facoltativa) riceve la data di un giorno e dice se non si puo' scegliere
const DateCalendar = ({ mode, selection, setSelection, isDayDisabled = () => false }) => {
  const initialDate = selection.length > 0 ? new Date(`${selection[0]}T00:00:00`) : new Date();
  const [ cursor, setCursor ] = useState(new Date(initialDate.getFullYear(), initialDate.getMonth(), 1));
  const [ view, setView ] = useState('days');

  const year = cursor.getFullYear();
  const month = cursor.getMonth();
  const firstYearOfBlock = year - (year % 12);

  const move = (direction) => {
    if (view === 'days') setCursor(new Date(year, month + direction, 1));
    else if (view === 'months') setCursor(new Date(year + direction, month, 1));
    else setCursor(new Date(year + 12 * direction, month, 1));
  }

  const handleSelectDay = (key) => {
    if (mode === 'single')
      setSelection([key]);
    else if (mode === 'multiple')
      setSelection(selection.includes(key) ? selection.filter(k => k !== key) : [...selection, key].sort());
    else
      setSelection(selection.length === 1 ? [selection[0], key].sort() : [key]);
  }

  // Le settimane partono dal lunedi': si arretra fino al lunedi' che precede il primo del mese
  const offset = (new Date(year, month, 1).getDay() + 6) % 7;
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const days = [...Array(Math.ceil((offset + daysInMonth) / 7) * 7).keys()].map(index => new Date(year, month, 1 - offset + index));

  const dayClassName = (date, key) => {
    const classNames = [];
    if (date.getMonth() !== month) classNames.push('outside');
    if (mode === 'range' && selection.length === 2) {
      if (key > selection[0] && key < selection[1]) classNames.push('in-range');
      if (key === selection[0]) classNames.push('range-start');
      if (key === selection[1]) classNames.push('range-end');
    }
    if (selection.includes(key)) classNames.push('selected');
    return classNames.join(' ');
  }

  return <React.Fragment>
    <div className="withdrawal-calendar-header">
      <button type="button" onClick={() => move(-1)}><img src={`${ICONS_PATH}/calendar-prev.svg`} width="10" height="10" alt="" /></button>
      <button type="button" onClick={() => setView(view === 'days' ? 'months' : 'years')}>
        {view === 'days' && `${monthName(month, 'long')} ${year}`}
        {view === 'months' && year}
        {view === 'years' && `${firstYearOfBlock} - ${firstYearOfBlock + 11}`}
      </button>
      <button type="button" onClick={() => move(1)}><img src={`${ICONS_PATH}/calendar-next.svg`} width="10" height="10" alt="" /></button>
    </div>

    {
      view === 'days' &&
        <div className="withdrawal-calendar-days">
          {WEEKDAYS().map(weekday => <span key={weekday} className="withdrawal-weekday">{weekday}</span>)}
          {
            days.map(date => {
              const key = dateKey(date);
              return <button type="button" key={key} className={dayClassName(date, key)} disabled={isDayDisabled(date)}
                             onClick={() => handleSelectDay(key)}>
                {date.getDate()}
              </button>
            })
          }
        </div>
    }

    {
      view === 'months' &&
        <div className="withdrawal-calendar-cells">
          {
            [...Array(12).keys()].map(monthIndex =>
              <button type="button" key={monthIndex} className={monthIndex === month ? 'current' : ''}
                      onClick={() => { setCursor(new Date(year, monthIndex, 1)); setView('days'); }}>
                {monthName(monthIndex, 'short')}
              </button>
            )
          }
        </div>
    }

    {
      view === 'years' &&
        <div className="withdrawal-calendar-cells">
          {
            [...Array(12).keys()].map(index => firstYearOfBlock + index).map(blockYear =>
              <button type="button" key={blockYear} className={blockYear === year ? 'current' : ''}
                      onClick={() => { setCursor(new Date(blockYear, month, 1)); setView('months'); }}>
                {blockYear}
              </button>
            )
          }
        </div>
    }
  </React.Fragment>
}

export default DateCalendar;
